import { Message, Modal } from '@metaarchit/govmo-web-ui';
import { getErrorMessage } from '@metaarchit/common-utils/lib/error';
export default {
  install(Vue, { i18n }) {
    Vue.prototype.$confirm = function ({
      title = i18n.t('MessagePlugin.title.tips'),
      message,
      confirmButtonText = i18n.t('MessagePlugin.action.confirm'),
      cancelButtonText = i18n.t('MessagePlugin.action.cancel'),
    }) {
      return new Promise((resolve, reject) => {
        Modal.confirm({
          title,
          okText: confirmButtonText,
          cancelText: cancelButtonText,
          keyboard: false,
          content: message,
          onOk: () => resolve(),
          onCancel: () => reject(),
        });
      });
    };

    Vue.prototype.$alert = function ({
      title = i18n.t('MessagePlugin.title.tips'),
      message,
      confirmButtonText = i18n.t('MessagePlugin.action.confirm'),
    }) {
      return new Promise((resolve) => {
        Modal.warning({
          title,
          okText: confirmButtonText,
          keyboard: false,
          content: message,
          onOk: () => resolve(),
        });
      });
    };

    Vue.prototype.$errorMessage = function (error) {
      const errorCodeMessageKey = 'ERROR_CODE_MESSAGE.';
      return typeof error === 'string'
        ? error
        : getErrorMessage(error, (key) =>
          i18n.t(`${errorCodeMessageKey}${key}`).replace(errorCodeMessageKey, ''),
        );
    };

    Vue.prototype.$error = function (error) {
      const message = Vue.prototype.$errorMessage(error);
      Message.error(message);
    };

    let loadingTextEl = null;
    const getLoadingContainer = function () {
      const mLoading = document.querySelector('.m-loading');
      if (mLoading) return mLoading;

      const wrappers = Array.from(document.querySelectorAll('.ant-modal-wrap'));
      for (let i = wrappers.length - 1; i >= 0; i -= 1) {
        const el = wrappers[i];
        if (el.querySelector('.ant-spin-spinning')) {
          return el;
        }
      }
      return null;
    };

    Vue.prototype.$showLoading = function (
      message = null
    ) {
      Vue.prototype.$loading();
      const loadingRoot = getLoadingContainer();
      if (!loadingRoot) return;
      const modalContent = loadingRoot.querySelector('.ant-modal-content');
      const modalBody = loadingRoot.querySelector('.ant-modal-body');
      const confirmBody = loadingRoot.querySelector('.ant-modal-confirm-body');
      const confirmContent = loadingRoot.querySelector('.ant-modal-confirm-content');
      const confirmBtns = loadingRoot.querySelector('.ant-modal-confirm-btns');
      const noneIcon = loadingRoot.querySelector('.anticon-none');

      if (modalContent) {
        modalContent.style.background = 'transparent';
        modalContent.style.boxShadow = 'none';
      }
      if (modalBody) {
        modalBody.style.padding = '0';
      }
      if (confirmBody) {
        confirmBody.style.display = 'flex';
        confirmBody.style.flexDirection = 'column';
        confirmBody.style.alignItems = 'center';
      }
      if (confirmBtns) {
        confirmBtns.style.display = 'none';
      }
      if (noneIcon) {
        noneIcon.style.display = 'none';
      }

      if (!message || !confirmContent) return;
      if (!loadingTextEl || !confirmContent.contains(loadingTextEl)) {
        loadingTextEl = document.createElement('div');
        loadingTextEl.className = 'm-loading-extra-message';
        loadingTextEl.style.marginTop = '12px';
        loadingTextEl.style.color = '#232323';
        loadingTextEl.style.fontSize = '16px';
        loadingTextEl.style.fontWeight = '500';
        loadingTextEl.style.textAlign = 'center';
        loadingTextEl.style.background = 'transparent';
        loadingTextEl.style.pointerEvents = 'none';
        confirmContent.appendChild(loadingTextEl);
      }
      loadingTextEl.textContent = message;
    };

    Vue.prototype.$hideLoading = function () {
      Vue.prototype.$loading(false);
      loadingTextEl = null;
    };
  },
};
